import React, { useEffect, useRef, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import BlogcardSection from "../BlogSection/BlogcardSection";
import CertificateCard from "../CertificateCard/CertificateCard";

import { useNavigate } from "react-router-dom";

const SiteMap = () => {
  const faqRef = useRef(null); // Create a reference for the FAQList component
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure the page scrolls to the top on reload
    if (window.location.hash) {
      // Remove any hash in the URL
      window.history.replaceState(null, null, " ");
    }
  }, []);

  const scrollToFAQ = () => {
    faqRef.current?.scrollIntoView({ behavior: "smooth" }); // Scroll to FAQList component
  };

  const items = [
    { label: "About us", path: "/about-us" },
    { label: "Blog", path: "/blog-component" },
    { label: "Contact us", path: "/contact-us" },
    { label: "FAQ's", path: "/faq" },
    { label: "My account", path: "/account" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Refund Policy", path: "/refund-policy" },
    { label: "Terms of Service", path: "/policies" },
    { label: "Sitemap", path: "/site-map" },
    { label: "Solutions", path: "/solutions" },
    // { label: "Vertex Suite Whatsapp Demo", path: "/whatsapp-demo" },
    {
      label: "Vertex Suite: An All-In-One SaaS Solution",
      path: "/",
    },
  ];

  const handleTermClick = () => {
    // navigate("/term-and-condition");
    navigate("/policies", { state: { termCondition1: "true" } });
  };
  const handlePrivacyClick = () => {
    // navigate("/privacy-policy");
    navigate("/policies", { state: { privacyPolicy1: "true" } });
  };
  const handleRefundClick = () => {
    // navigate("/refund-policy");
    navigate("/policies", { state: { refundPloicy1: "true" } });
  };

  return (
    <>
      <Header />
      <main>
        <Stack sx={{ display: "flex", flexDirection: "column" }}>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "black",
            }}
          >
            <Stack
              sx={{
                width: {
                  xl: "69%",
                  lg: "80%",
                  md: "90%",
                  sm: "96%",
                  xs: "100%",
                },
                //   border: "1px solid red",
              }}
            >
              <Stack
                sx={{
                  //   border: "1px solid red",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: { sm: "20vh", xs: "15vh" },
                  gap: 4,
                  backgroundColor: "black",
                }}
              >
                <Stack
                  sx={{
                    fontSize: {
                      xl: "60px",
                      lg: "60px",
                      sm: "40px",
                      xs: "40px",
                    },
                    fontWeight: 400,
                    color: "white",
                    lineHeight: "24px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Sitemap
                </Stack>
                <Stack
                  sx={{
                    fontSize: {
                      xl: "20px",
                      lg: "20px",
                      sm: "20px",
                      xs: "16px",
                    },
                    fontWeight: 400,
                    color: "white",
                    lineHeight: "24px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  HOME / SITEMAP
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              //   backgroundColor: "#f9f9f9",
            }}
          >
            <Stack
              sx={{
                width: {
                  xl: "70%",
                  lg: "80%",
                  md: "90%",
                  sm: "96%",
                  xs: "100%",
                },
                //   border: "1px solid red",

                padding: 2,
                marginBottom: "40px",
                marginTop: "40px",
              }}
            >
              <Stack
                sx={{
                  //   border: "1px solid red",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  sx={{
                    width: { sm: "40%", xs: "100%" },
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <Stack
                    sx={{
                      fontSize: {
                        xl: "32px",
                        lg: "32px",
                        sm: "32px",
                        xs: "28px",
                      },
                      fontWeight: 600,
                      color: "black",
                      lineHeight: "24px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Pages
                  </Stack>
                  <Stack spacing={1} component="ul" sx={{ pl: 2, m: 0 }}>
                    {items.map((item, index) => (
                      <Typography
                        key={index}
                        component="li"
                        sx={{
                          listStyleType: "disc",
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "18px",
                          },
                          color: "#333",
                          cursor: "pointer",
                          transition: "color 0.3s",
                          "&:hover": {
                            color: "blue",
                          },
                        }}
                        onClick={() => {
                          if (index === 5) {
                            handlePrivacyClick();
                          } else if (index === 6) {
                            handleRefundClick();
                          } else if (index === 7) {
                            handleTermClick();
                          } else {
                            navigate(item.path);
                          }
                        }}
                      >
                        {item.label}
                      </Typography>
                    ))}
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    display: { sm: "flex", xs: "none" },
                    width: { sm: "60%" },
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    // border: "1px solid red",
                  }}
                >
                  <Stack></Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <BlogcardSection />
        {/* <CommentSection /> */}
        <CertificateCard />
      </main>
      <Footer onFAQClick={scrollToFAQ} />{" "}
    </>
  );
};

export default SiteMap;
